/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkCenterData } from '../../models/work-center-data';

export interface GetWorkCenterList$Params {
}

export function getWorkCenterList(http: HttpClient, rootUrl: string, params?: GetWorkCenterList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WorkCenterData>>> {
  const rb = new RequestBuilder(rootUrl, getWorkCenterList.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<WorkCenterData>>;
    })
  );
}

getWorkCenterList.PATH = '/api/v1/WorkCenter';
